import { useEffect } from 'react';
import { FormikProps } from 'formik';

import { MaterialRequisitionItemFormResponse } from '@Types/api/form';
import { useGetRequisitionItemQuery } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';

import ModalContent from './components/ModalContent';

interface EditModalContentProps {
  itemId: string | number;
  formik: FormikProps<MaterialRequisitionItemFormResponse>;
}

const EditModalContent: React.FC<EditModalContentProps> = ({
  itemId,
  formik,
}) => {
  const { data } = useGetRequisitionItemQuery(String(itemId));

  useEffect(() => {
    if (data) {
      formik.setValues({
        ...data,
      });
    }
  }, [data]);

  return <ModalContent formik={formik} />;
};

export default EditModalContent;
